'use client';

import React from 'react';
import Link from 'next/link';
import styles from './page.module.scss';
import type { ContentItem } from '@/lib/mdx';

interface CaseDetailClientProps {
  caseData: ContentItem;
}

export default function CaseDetailClient({ caseData }: CaseDetailClientProps) {
  const { frontMatter, content } = caseData;

  return (
    <article className={styles.caseDetail}>
      <nav className={styles.breadcrumb} aria-label="パンくずリスト">
        <ol>
          <li><Link href="/">ホーム</Link></li>
          <li><Link href="/cases/">事例紹介</Link></li>
          <li><Link href="/cases/own-projects/">自社事例</Link></li>
          <li aria-current="page">{frontMatter.title}</li>
        </ol>
      </nav>

      <header className={styles.header}>
        <h1 className={styles.title}>{frontMatter.title}</h1>
        <p className={styles.description}>{frontMatter.description}</p>
        <div className={styles.metadata}>
          <time className={styles.date}>{frontMatter.publishedAt}</time>
          <div className={styles.tags}>
            {frontMatter.tags?.map((tag: string) => (
              <span key={tag} className={styles.tag}>{tag}</span>
            ))}
          </div>
        </div>
      </header>

      <div className={styles.content}>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>

      <section className={styles.projectInfo}>
        <h2>プロジェクト情報</h2>
        <dl className={styles.infoList}>
          <dt>プロジェクト名</dt>
          <dd>{frontMatter.title}</dd>
          <dt>カテゴリー</dt>
          <dd>自社事例</dd>
          <dt>公開日</dt>
          <dd>{frontMatter.publishedAt}</dd>
          <dt>URL</dt>
          <dd>
            <a 
              href="https://www.youtube.com/@baysgaia_lab" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.externalLink}
            >
              @baysgaia_lab
              <span className={styles.externalIcon}>↗</span>
            </a>
          </dd>
        </dl>
      </section>

      <nav className={styles.caseNav}>
        <Link href="/cases/own-projects/" className={styles.backLink}>
          ← 自社事例一覧に戻る
        </Link>
      </nav>
    </article>
  );
}